export default __webpack_public_path__ + "static/media/icon-powiadomienie sms.7645160c.svg";